// extracted by mini-css-extract-plugin
export var aggregationCell = "_87-n";
export var aggregationRow = "_87-m";
export var borderlessSpinnerContainer = "_87-3";
export var cardLayout = "_87-6";
export var cardLayoutNoFooter = "_87-9";
export var cardLayoutPageControl = "_87-8";
export var closeIcon = "_87-f";
export var columnHeaderSurface = "_87-b";
export var columnHeaderSurfaceDragOverlay = "_87-v";
export var columnHeaderSurfaceResizing = "_87-s";
export var contextMenuAnchor = "_87-1";
export var draggableColumnHeader = "_87-t";
export var draggableColumnHeaderOverlay = "_87-u";
export var expandIcon = "_87-g";
export var expanded = "_87-h";
export var filterDropdown = "_87-i";
export var filterDropdownDivider = "_87-d";
export var filterDropdownHeader = "_87-l";
export var filterDropdownItem = "_87-k";
export var filterDropdownModal = "_87-j _87-i";
export var filterItem = "_87-c";
export var normalCellWithAdjustableBorder = "_87-e";
export var pinButtonContainer = "_87-o";
export var pinIcon = "_87-p";
export var pinIconActive = "_87-q";
export var spinner = "_87-0";
export var spinnerContainer = "_87-2";
export var tableContainer = "_87-4";
export var tableContentDraggingColumns = "_87-a";
export var tableContentInner = "_87-7";
export var tableContentWrapper = "_87-5";
export var viewButtonContainer = "_87-r";